var lib_core = require("lib-core");

var MovingModel = function (editorModel) {
    lib_core.Model.apply(this);

    this.editorModel = editorModel;

    this.isMoving = this.value("isMoving", true);
};
lib_core.inherit(MovingModel, lib_core.Model);
lib_core.JsonParser.registerClass(MovingModel, "MovingModel");

module.exports = MovingModel;

MovingModel.prototype.getMoveCollection = function() {
    return this.editorModel.selectionModel().selection;
};

MovingModel.prototype.onElementMovingStart = function(keys) {
    var collection = this.getMoveCollection();
    if(collection) {
        collection.forEach(function (element) {
            if(element.onElementMovingStart) element.onElementMovingStart(keys);
        });
    }

    // create collections for controlling snap behaviour
    this._snapCollection = [];
    if (this.getMoveHandle()) this._snapCollection.push(this.getMoveHandle());
    if (this.getMoveSubHandle()) this._snapCollection.push(this.getMoveSubHandle());
    if (!this._snapCollection.length) this._snapCollection = this.getMoveCollection();
    this._ignoreCollection = this.getMoveCollection().copy().removeAll(this._snapCollection);
};

MovingModel.prototype.move = function(vec, keys) {
    this.getMoveCollection().forEach(function(element) {
        element.move(vec, keys);
    });
};

MovingModel.prototype.onElementMovingStop = function(keys) {
    var collection = this.getMoveCollection();
    if(collection) {
        collection.forEach(function (element) {
            if(element.onElementMovingStop) element.onElementMovingStop(keys);
        });
    }

    this._snapCollection = null;
    this._ignoreCollection = null;
};

MovingModel.prototype.getMoveHandle = function() {
    return this.editorModel.selectionModel().clickedElement();
};

MovingModel.prototype.getMoveSubHandle = function() {
    return this.editorModel.selectionModel().selectedSubElement();
};

